<template>
  <div :class="[!hideTop && platform !== 'miniProgram' ? 'ptop' : '']">
    <van-nav-bar
      class="backarrow"
      :title="title"
      left-arrow
      @click-left="goback"
      v-if="!hideTop && platform !== 'miniProgram'"
    />
    <!-- <transition :name="transitionName"> -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        class="child-view"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="child-view"
    ></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
export default {
  name: "layout",
  data() {
    return {
      title: "",
      hideTop: false,
      transitionName: "slide-left",
      isback: false,
      platform: "miniProgram",
      isopen: false,
    };
  },
  watch: {
    $route(to, from) {
      // alert(from.name)
      if (to.query.minit && !from.name) {
        this.platform = "miniProgram";
        Vue.prototype.$platform = "miniProgram";
      }
      if (!to.query.minit && !from.name) {
        this.platform = "";
        Vue.prototype.$platform = "";
      }
      // localStorage.setItem("moduleName",to.meta.title);
      // localStorage.setItem("curl",to.path);
      if (to) {
        this.setMeta(to);
      }
      this.transitionName = this.isback ? "slide-right" : "slide-left";
      this.isback = false;
      // if(from.path=='/goodsList' && to.path=='/category'){
      //     to.meta.keepAlive = true;
      // }else{
      //     to.meta.keepAlive = false;
      // }
      if (from.path == "/orderDetail" && to.path == "/orderList") {
        to.query.active = from.query.active;
      }
    },
  },
  created() {
    let that = this;
    // that.getVersion("1.0.0")
    window.openApp = function (pf, version) {
      if (that.isopen) return;
      Vue.prototype.$platform = pf;
      that.getVersion(version);
      localStorage.setItem("burryAppname", "O2Onativeapp");
      that.isopen = true;
    };
    // console.log(this.platform,'platform')
    // window.openApp('android','2.0.0')
  },
  mounted() {
    // this.platform = Vue.prototype.$platform
    // setTimeout(()=>{
    //  this.platform = Vue.prototype.$platform
    // },100)
    // TODO:审核版本之后去掉
    // if(window.android){
    //   try{
    //     const version = window.android.versionUpdate()
    //     // 2.0.0版本写死暂时
    //     if(version == '2.0.0'){
    //       this.setShow(false)
    //     }
    //   }catch(e){
    //     // this.$toast(e)
    //     // that.getVersionOld("2.0.0")
    //   }
    // }

    this.setMeta(this.$route);
  },
  methods: {
    ...mapActions("app", ["setShow"]),
    async getVersion(version) {
      let params = {
        versionCode: 100,
        platform: 2,
        os: 0,
      };
      // this.$toast(`version:${version}-layout`);
      try {
        let res = await this.$service.androidVersionCode(params);
        let andres = res.result ? JSON.stringify(res.result) : "";
        // this.$toast(`version:${version}-layout-${andres}`);
        if (andres) {
          // 高版本模块隐藏
          if (version > res.result.versionCode) this.setShow(false);
          if (version < res.result.versionCode) window.android.versionResponse(andres);
        }
        // return andres
      } catch (e) {
        this.$toast(`异常：${e}`);
      }
    },
    goback() {
      this.isback = true;
      this.$router.back();
    },
    setMeta(route) {
      // console.log('route',route,this.platform)
      // if(route.query.minit){
      //   this.platform = "miniProgram"
      // }
      let title =
        process.env.VUE_APP_TITLE === "PRO" ? "" : process.env.VUE_APP_TITLE;
      if (route.name === "outerPage") {
        let pname = localStorage.getItem(this.$env + "outPageTitle") || "";
        this.title = pname + " " + title;
        return;
      }
      this.title = route.meta.title + " " + title;
      this.hideTop = route.meta.hideTop;
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.backarrow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.backarrow .van-icon {
  color: #f84f24;
  font-size: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.child-view {
  position: relative;
  transition: all 0.3s ease-out;
}
.ptop {
  padding-top: 1.2267rem;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(10rem, 0);
  transform: translate(10rem, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-10rem, 0);
  transform: translate(-10rem, 0);
}
</style>
